import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import useClientContactService from '../../../app/services/hooks/useClientContactService';
import { ClientContactDataForm } from '../../../app/models/ClientContact';
import { ContactType } from '../../../app/models/ContactType';
import ClientContactForm from './forms/ClientContactForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';

interface Props {
    clientContactId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const ClientContactEdit = ({ clientContactId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingEditClientContact, editClientContact, fetchingUpdateClientContact, updateClientContact } =
        useClientContactService();

    const [clientContact, setClientContact] = useState<ClientContactDataForm>(
        { 
            name: '', 
            email: '', 
            contact_type_id: 0 
        }
    );
    const [contactTypes, setContactTypes] = useState<ContactType[]>([]);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando contacto cliente...');
        editClientContact(clientContactId, {
            onSuccess: (response: ServiceResponse) => {
                setContactTypes(response.data.contact_types);
                setClientContact(response.data.client_contact);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando contacto cliente...');
        updateClientContact(clientContactId, clientContact, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditClientContact ? (
        <LazyLoading height={300} />
    ) : (
        <>
            <div className="row">
                <div className="col-12">
                    <ClientContactForm
                        clientContactDataForm={clientContact}
                        setClientContactDataForm={setClientContact}
                        contactTypes={contactTypes}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm
                        callbackCancel={cancel}
                        locked={fetchingUpdateClientContact}
                    />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={update} locked={fetchingUpdateClientContact} />
                </div>
            </div>
        </>
    );
};

export default ClientContactEdit;
